import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

type IncomeType = 'employment' | 'investment' | 'rental' | 'other';

interface IncomeTypeSelectionProps {
  selectedTypes: IncomeType[];
  otherIncome: string;
  onTypeChange: (type: IncomeType) => void;
  onOtherIncomeChange: (value: string) => void;
}

export function IncomeTypeSelection({
  selectedTypes,
  otherIncome,
  onTypeChange,
  onOtherIncomeChange
}: IncomeTypeSelectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="employment"
          checked={selectedTypes.includes('employment')}
          onCheckedChange={() => onTypeChange('employment')}
        />
        <Label htmlFor="employment">Employment Income (Salary & Wages)</Label>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="investment"
          checked={selectedTypes.includes('investment')}
          onCheckedChange={() => onTypeChange('investment')}
        />
        <Label htmlFor="investment">Investment Income (Shares, Interest)</Label>
      </div>
      
      <div className="flex items-center space-x-2">
        <Checkbox 
          id="rental"
          checked={selectedTypes.includes('rental')}
          onCheckedChange={() => onTypeChange('rental')}
        />
        <Label htmlFor="rental">Rental Income</Label>
      </div>

      <div className="space-y-2">
        <Label>Other Income Sources (Optional)</Label>
        <Textarea
          placeholder="E.g., Business income, foreign income, etc."
          value={otherIncome}
          onChange={(e) => onOtherIncomeChange(e.target.value)}
        />
      </div>
    </div>
  );
}